module.exports = __webpack_public_path__ + "img/erweima.8ce90ca0.png";